import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Agent, AgentUpdate } from "@/model";
import agentRepository from "@/repository/agentRepository";
import { agentQueryKeys } from "./keys";

export const useUpdateAgent = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Agent, AxiosError, AgentUpdate>({
        mutationKey: ["agent", "update"],
        mutationFn: async (body: AgentUpdate) => {
            try {
                const { data } = await agentRepository.update(body.agent_id, body);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: agentQueryKeys.read(agentId),
                exact: false
            });
        }
    });
};
